<template>
    <input
        :value="modelValue"
        :readonly="readonly"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
        :class="readonly ? 'bg-gray-100' : ''"
        class="appearance-none block px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-indigo focus:border-indigo-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
    />
</template>

<script>
export default {
    name: 'FormInput',
    props: {
        modelValue: {
            required: true,
        },
        readonly: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        focusInput() {
            this.$nextTick(function () {
                this.$refs.input.focus();
            });
        },
    },
};
</script>
